<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/add-kid.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        @if (step() === 'verify') {
          {{ 'app.components.addKid.verifyTitle' | translate }}
        } @else {
          {{ 'app.components.addKid.title' | translate }}
        }
      </h2>
      <p class="parent-dialog__subtitle">
        @if (step() === 'verify') {
          {{ 'app.components.addKid.verifySubTitle' | translate }}
        } @else {
          {{ 'app.components.addKid.subTitle' | translate }}
        }
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.addKid.close' | translate"
    (click)="discard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (familyBlocked()) {
    <section class="parent-dialog__section">
      <p class="parent-dialog__hint">
        {{ 'app.components.addKid.familyBlockedBody' | translate }}
      </p>
    </section>
  } @else if (step() === 'details') {
    <form class="parent-dialog__form" [formGroup]="kidForm">
      <app-input-field
        formControlName="firstName"
        [placeholder]="'app.components.addKid.firstNamePlaceholder' | translate"
        [label]="'app.components.addKid.firstName' | translate"
        [validationErrors]="firstNameValidation()"
      />

      <app-input-field
        formControlName="lastName"
        [placeholder]="'app.components.addKid.lastNamePlaceholder' | translate"
        [label]="'app.components.addKid.lastName' | translate"
        [validationErrors]="lastNameValidation()"
      />

      <app-input-field
        formControlName="birthDate"
        [label]="'app.components.addKid.birthDate' | translate"
        [placeholder]="'app.components.addKid.birthDatePlaceholder' | translate"
        [inputType]="'datepicker'"
        [type]="'date'"
        [validationErrors]="birthDateValidation()"
      />

      <app-input-field
        formControlName="email"
        [placeholder]="'app.components.addKid.emailPlaceholder' | translate"
        [label]="'app.components.addKid.email' | translate"
        [type]="'email'"
        [validationErrors]="emailValidation()"
        (keydown.enter)="sendInvite()"
      />
    </form>
  } @else if (verifyKidId()) {
    <app-kid-document-verify
      [kidId]="verifyKidId()!"
      [kidFirstName]="verifyFirstName()"
      [kidLastName]="verifyLastName()"
      [kidBirthDate]="verifyBirthDate()"
      (completed)="onVerificationCompleted()"
      (cancelled)="discard()"
    />
  }
</mat-dialog-content>

@if (step() === 'details') {
  <mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
    @if (familyBlocked()) {
      <app-parent-button variant="ghost" (clicked)="discard()">
        {{ 'app.components.addKid.discard' | translate }}
      </app-parent-button>
      <app-parent-button variant="primary" (clicked)="startParentVerification()">
        {{ 'app.components.addKid.familyBlockedCta' | translate }}
      </app-parent-button>
    } @else {
      <app-parent-button variant="ghost" (clicked)="discard()">
        {{ 'app.components.addKid.discard' | translate }}
      </app-parent-button>

      <app-parent-button
        variant="primary"
        [loading]="isLoading()"
        [disabled]="!canConfirm()"
        (clicked)="sendInvite()"
      >
        @if (!isLoading()) {
          <img src="/public/svgs/send-w.svg" alt="" width="14" height="14" aria-hidden="true" />
        }
        @if (requiresDocumentVerification()) {
          {{ 'app.components.addKid.continueToVerify' | translate }}
        } @else {
          {{ 'app.components.addKid.sendInvite' | translate }}
        }
      </app-parent-button>
    }
  </mat-dialog-actions>
}
